export class HouseholdRouteConstants {
  static aanmelden = 'aanmelden';
  static aanmeldenNietMogelijk = 'aanmelden-niet-mogelijk';
  static afmelden = 'afmelden';
  static householdRoot = 'klantvoordeel';
  static wachtOpMobiel = 'verstuurd/aanmelding-in-behandeling';
}
